<template>
    <b-modal v-cloak id="modal-share-envio" hide-header hide-footer :content-class="{'rojo': anyError}" centered  :size="anyError||share.success ? 'md' : 'lg'" style="padding: 15px">
        <div v-show="!anyError">
            <div v-show="!share.success">
                <i class="fa fa-times float-right cursor_pointer" @click="$bvModal.hide('modal-share-envio')"></i>
                <div class="d-block" style="color: black; font-size: 1.1rem">
                    Si conoces a otro agricultor que haya realizado un pedido en nuestra tienda online para la misma semana de tu pedido, podemos unificar
                    los gastos de envío o incluso ahorrarlos si entre ambos superais las 12 bandejas entregando los pedidos en una única dirección.
                </div>
                <img src="/img/ayuda/envio-compartido.png" alt="Envio compartido logo" class="img-fluid">
                <div class="d-block" style="color: black; font-size: 1.1rem">
                    Introduce su número de pedido para poder unificar el envío
                </div>

                <div class="row">
                    <div class="col-md-6">
                        <div class="bp-form-group" style="padding-top: 15px">
                            <div class="content-group">
                                <div>
                                    <div class="content-input">
                                        <input id="numero-envio" style="border-width: 2px" type="text" class="form-element" v-model="num_order" placeholder="Introduce número pedido">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <b-button class="alter-btn" id="shareButtonSubmit" @click="submitShare"><span>Enviar</span></b-button>
                    </div>
                </div>
            </div>
            <div v-show="share.success">
                <i class="fa fa-times float-right cursor_pointer" @click="resetSuccessShare"></i>
                <p class="mx-auto" style="text-align: center; font-size: 2rem">
                    ¡Tu pedido será enviado junto al pedido que has indicado!
                </p>
            </div>
        </div>
        <div v-show="anyError">
            <div v-show="this.share.errorPedidoNoExiste" class="mx-auto">
                <i class="fa fa-times float-right cursor_pointer" @click="resetErrorsShare"></i>
                <p class="mx-auto" style="text-align: center;  font-size: 2rem">
                    ¡El número de pedido que indicas no existe para la misma semana de envio!
                </p>
            </div>
            <div v-show="this.share.errorNoSePuede">
                <i class="fa fa-times float-right cursor_pointer" @click="resetErrorsShare"></i>
                <p class="mx-auto" style="text-align: center; font-size: 2rem">
                    ¡Tu pedido no puede ser enviado junto al pedido que indicas!
                </p>
            </div>
        </div>
    </b-modal>
</template>

<script>
    export default {
        data() {
            return {
                share: {
                    errorPedidoNoExiste: false,
                    errorNoSePuede: false,
                    success: false
                },
                num_order: '',
                semana: '',
                ship_id: '',
                errors: ''
            }
        },
        methods: {
            resetErrorsShare: function () {
                this.share.errorPedidoNoExiste = false;
                this.share.errorNoSePuede = false;
            },
            resetSuccessShare: function () {
                this.share.success = false;
            },
            submitShare: function(){
                axios.post(this.route('carrito.share.shipping'),{
                    num_order: this.num_order,
                    semana: this.weekN,
                    year: this.yearN,
                    ship_id: this.ship_id,
                }).then(response => {
                    this.$emit('exit', true);
                    this.errors = '';
                    this.share.success = true;
                    this.num_order = '';
                    this.$root.$emit('loadCartInfo');

                    if(this.$parent.$parent.$refs['shipBlock-'+this.semana]){
                        this.$parent.$parent.$refs['shipBlock-'+this.semana][0].loadInfo();
                    }

                    Vue.toasted.show(response.data.info, {
                        type: "success",
                        duration: 3000
                    });
                }).catch(e => {
                    if (e.response.status === 422) {
                        console.log(e.response.data.no_exist);
                        this.errors = e.response.data.errors;
                        if(e.response.data.no_exist){
                            this.share.errorPedidoNoExiste = true;
                            this.share.errorNoSePuede = false;
                        }else{
                            this.share.errorNoSePuede = true;
                            this.share.errorPedidoNoExiste = false;
                        }
                    }
                });
            }
        },
        computed: {
            anyError: function () {
                return this.share.errorNoSePuede || this.share.errorPedidoNoExiste;
            },
            yearN() {
                return this.semana.substring(0, 4);
            },
            weekN() {
                return this.semana.substring(5);
            }
        }
    }
</script>

<style lang="scss">
    #shareEnvio:hover{
        background-color:rgb(0, 113, 188);
    }

    #shareEnvio:hover span{
        color: white;
    }

    #shareButtonSubmit{
        border-color: rgb(0, 113, 188);
        margin-top: 15px;
        max-width: 100%;

        span{
            color: rgb(0, 113, 188);
        }
    }

    #shareButtonSubmit:hover{
        background-color: green !important;
        font-weight: bold !important;

        span{
            color: white;
        }
    }

    #modal-share-envio___BV_modal_body_{
        padding: 30px !important;
    }
</style>
